import {useTranslation} from 'react-i18next'

import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledBillValue, StyledItem, StyledResult, StyledSectionHeader, StyledSign, StyledTitle} from './style'
import {correctCurrency} from '@/utilities/constants'
import {formatValues} from '@/features/project-details/helpers/helpers'

type SavingDifferenceType = {
    first: number
    second: number
    result: number
}

export const FinancialImpactHeader = ({savingDifference}: {savingDifference: SavingDifferenceType}) => {
    const {t} = useTranslation()

    return (
        <StyledSectionHeader justify="space-between" align="center">
            <StyledTitle>{t('quote:financial_impact:title')}</StyledTitle>
            <Flexbox gap={4} align="start">
                <StyledItem direction="column" gap={1} align="center">
                    <span>
                        {formatValues(savingDifference.first, 2)} {correctCurrency}
                    </span>
                    <StyledBillValue>{t('quote:financial_impact:bill_value')}</StyledBillValue>
                </StyledItem>
                <StyledSign>-</StyledSign>
                <StyledItem direction="column" gap={1} align="center">
                    <span>
                        {formatValues(savingDifference.second, 2)} {correctCurrency}
                    </span>
                    <p>{t('quote:financial_impact:system_cost')}</p>
                </StyledItem>
                <StyledSign>=</StyledSign>
                <StyledResult direction="column" gap={1} align="center">
                    <span>
                        {formatValues(savingDifference.result, 2)} {correctCurrency}
                    </span>
                    <p>{t('quote:financial_impact:result')}</p>
                </StyledResult>
            </Flexbox>
        </StyledSectionHeader>
    )
}
